import PropTypes from 'prop-types'

const Box = ({ title, label, headerActions, content }) => (
  <div className="reputation-management-page__box">
    <div className="reputation-management-page__box-header">
      <h3 className="reputation-management-page__box-title">
        {title} {label}
      </h3>
      <div>{headerActions}</div>
    </div>
    <div className="reputation-management-page__box-divider" />
    <div className="reputation-management-page__box-content">{content}</div>
  </div>
)

Box.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.element,
  headerActions: PropTypes.element,
  content: PropTypes.element.isRequired,
}

export default Box
